import {
  LOAD_PRODUTOS,
  SET_LISTVIEW,
  SET_GRIDVIEW,
  UPDATE_SORT,
  SORT_PRODUTOS,
  UPDATE_FILTERS,
  FILTER_PRODUTOS,
  CLEAR_FILTERS,
} from '../actions'

const filter_reducer = (state, action) => {
  if (action.type === LOAD_PRODUTOS) {
    return {
      ...state,
      all_produtos: [...action.payload],
      filtered_produtos: [...action.payload],
      
    }
  }
  if (action.type === SET_GRIDVIEW) {
    return { ...state, grid_view: true }
  }
  if (action.type === SET_LISTVIEW) {
    return { ...state, grid_view: false }
  }
  if (action.type === UPDATE_SORT) {
    return { ...state, sort: action.payload }
  }
  if (action.type === SORT_PRODUTOS) {
    const { sort, filtered_produtos } = state
    let tempProdutos = [...filtered_produtos]
   
    if (sort === 'name-a') {
      tempProdutos = tempProdutos.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
    }
    if (sort === 'name-z') {
      tempProdutos = tempProdutos.sort((a, b) => {
        return b.name.localeCompare(a.name)
      })
    }
    return { ...state, filtered_produtos: tempProdutos }
  }
  if (action.type === UPDATE_FILTERS) {
    const { name, value } = action.payload
    return { ...state, filters: { ...state.filters, [name]: value } }
  }
  if (action.type === FILTER_PRODUTOS) {
    const { all_produtos } = state
    const { text, category, company, color, shipping } = state.filters

    let tempProdutos = [...all_produtos]
    // filtering
    // text
    if (text) {
      tempProdutos = tempProdutos.filter((produtos) => {
        return produtos.name.toLowerCase().startsWith(text)
      })
    }
    // category
    if (category !== 'all') {
      tempProdutos = tempProdutos.filter(
        (produtos) => produtos.category === category
      )
    }

    // company
    if (company !== 'all') {
      tempProdutos = tempProdutos.filter(
        (produtos) => produtos.company === company
      )
    }
    // colors
    if (color !== 'all') {
      tempProdutos = tempProdutos.filter((produtos) => {
        return produtos.colors.find((c) => c === color)
      })
    }
    // price
   
    // shipping
    if (shipping) {
      tempProdutos = tempProdutos.filter((produtos) => produtos.shipping === true)
    }

    return { ...state, filtered_produtos: tempProdutos }
  }
  if (action.type === CLEAR_FILTERS) {
    return {
      ...state,
      filters: {
        ...state.filters,
        text: '',
        company: 'all',
        category: 'all',
        color: 'all',
        shipping: false,
      },
    }
  }
  throw new Error(`No Matching "${action.type}" - action type`)
}

export default filter_reducer
